import { IInvolvedParty, IKeywords } from './../../../../common/sharedTypes';
import moment from 'moment';
import { initialInvolvedParty } from '../business-objects/common';
import { REPORT_TYPE_INVESTIGATOR_ID } from '../../../shared/constants';

export function validateDateOfCrash(dateOfCrash: string): {
  isValid: boolean;
  message: string;
} {
  const validDateOfCrash = dateOfCrash && moment(dateOfCrash).isValid();
  if (!validDateOfCrash)
    return { isValid: false, message: 'Date selection required' };

  const crashYear = new Date(dateOfCrash).getFullYear();
  const firstCrashYear = 2021;

  const isAfterToday = moment(dateOfCrash).isAfter(moment());

  if (!(crashYear >= firstCrashYear)) {
    return {
      isValid: false,
      message: `Year must be greater than or equal to ${firstCrashYear}`,
    };
  }

  if (isAfterToday) {
    return { isValid: false, message: 'Date cannot be a future date' };
  }

  return { isValid: true, message: '' };
}

export function hasValue(value: any) {
  return value ? true : false;
}

export function validateAgency(keywords: IKeywords) {
  const hasValidAgency =
    keywords.reportTypeId != REPORT_TYPE_INVESTIGATOR_ID ||
    hasValue(keywords.agencyId);

  return hasValidAgency;
}

export function validateNarrativeDiagram(keywords: IKeywords) {
  const hasValidNarrativeDiagram =
    keywords.reportTypeId != REPORT_TYPE_INVESTIGATOR_ID ||
    (keywords.narrativeDiagramPages &&
      keywords.narrativeDiagramPages.length > 0);

  return hasValidNarrativeDiagram;
}

export function handleInvolvedPartyChange(
  event: any,
  keywords: IKeywords
): IInvolvedParty[] {
  const { name, type, checked } = event.target;
  let { value } = event.target;

  const { involvedParties } = keywords;

  switch (name) {
    case 'addInvolvedParty':
      // ensures there is always one involved party
      if (involvedParties.length === 0) {
        return [initialInvolvedParty];
      } else {
        return [
          ...involvedParties,
          {
            keywordsId: keywords.id,
            id: Math.floor(Math.random() * -1000) + involvedParties.length,
            firstName: '',
            lastName: '',
            businessName: '',
          },
        ];
      }
    case 'deleteInvolvedParty':
      const nonDeletedInvolvedParties = involvedParties.filter(
        (ip) => ip.id != value
      );

      return nonDeletedInvolvedParties;
    default:
      const parts = name.split('|');
      const id = parts[0];
      const key = parts[1];
      if (type === 'checkbox') value = checked;

      const updatedInvolvedParty = {
        ...involvedParties.find((ip) => ip.id == id),
        [key]: value,
      };

      return involvedParties.map((ip) =>
        ip.id == id ? updatedInvolvedParty : ip
      );
  }
}
